import switchProject from '../Services/switchProject'

export default () => (dispatch) => {

  dispatch(switchProject())

}
